module.exports = __webpack_public_path__ + "static/media/ZM.acad9df9.svg";